import { render, staticRenderFns } from "./CostEstimate.vue?vue&type=template&id=88008824&scoped=true&"
import script from "./CostEstimate.vue?vue&type=script&lang=js&"
export * from "./CostEstimate.vue?vue&type=script&lang=js&"
import style0 from "./CostEstimate.vue?vue&type=style&index=0&id=88008824&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88008824",
  null
  
)

export default component.exports